export * from 'messages/constants/messages_constants';



// WEBPACK FOOTER //
// src/modules/messages/constants/index.js